import { PublicClientApplication, LogLevel, } from "@azure/msal-browser";
import { msalConfig as configFromFile } from "./auth-config";
export const msalConfig = Object.assign(Object.assign({}, configFromFile), { system: {
        loggerOptions: {
            loggerCallback: () => { },
            logLevel: LogLevel.Info,
        },
    } });
export const pca = new PublicClientApplication(msalConfig);
// Single initialization + redirect handling promise.
// MsalProvider also calls handleRedirectPromise internally,
// so we just initialize here and let MsalProvider handle the redirect.
export const msalInitialized = pca.initialize().then(() => { });
// This resolves once we know accounts are available (after redirect processing).
// Set by AuthProvider after MsalProvider has processed the redirect.
let msalReadyResolve;
export const msalReady = new Promise((resolve) => {
    msalReadyResolve = resolve;
});
export function signalMsalReady() {
    const active = pca.getActiveAccount();
    const accounts = pca.getAllAccounts();
    if (!active && accounts.length > 0) {
        pca.setActiveAccount(accounts[0]);
    }
    msalReadyResolve();
}
